import axios from 'axios'
import router from "@/router"
import { decrypt } from './crypto'

const request = axios.create({
    // baseURL: 'http://localhost:9090',
    baseURL: 'https://back.geek-coding.cn/api/',
    timeout: 500000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
    if (user) {
        config.headers['token'] = user.token;  // 设置请求头
    }

    // ⚠️ 请求不加密，直接发送原始数据
    console.log('📤 发送请求（未加密）:', config.url)

    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;

        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }

        // 如果是加密数据（字符串格式），进行解密
        if (typeof res === 'string' && res && !response.config.skipDecrypt) {
            try {
                // 尝试解密
                const decrypted = decrypt(res)
                res = JSON.parse(decrypted)
                console.log('✅ 响应已解密:', response.config.url)
            } catch (error) {
                // 解密失败，可能是未加密的数据，尝试直接解析
                console.warn('⚠️ 解密失败，尝试直接解析:', response.config.url, error)
                try {
                    res = JSON.parse(res)
                } catch (parseError) {
                    console.error('❌ JSON 解析失败:', parseError)
                }
            }
        }

        // 当权限验证不通过的时候给出提示
        if (res && res.code === '401') {
            // ElementUI.Message({
            //     message: res.msg,
            //     type: 'error'
            // });
            router.push("/login")
        }

        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

// 导出 baseURL 供 fetch 流式请求使用
export const baseURL = request.defaults.baseURL

// 获取带 token 的 headers（用于 fetch 请求）
export function getHeaders(contentType = 'application/json') {
    const headers = {}
    if (contentType) {
        headers['Content-Type'] = contentType
    }
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
    if (user && user.token) {
        headers['token'] = user.token
    }
    return headers
}

export default request

